import React from 'react'

import { Box, P, PBig } from '../../components'
import { useTranslation } from '../../i18n'

const EmptyState: React.FC = () => {
  const { t } = useTranslation('main-tenantPreference')
  return (
    <Box
      width='100%'
      height='100%'
      flexGrow={1}
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
    >
      <PBig mb={1}>{t('emptyState.title')}</PBig>
      <P color={60}>{t('emptyState.description')}</P>
    </Box>
  )
}

export { EmptyState }
